// extracted by mini-css-extract-plugin
export default {"root":"AdminPage_root__0AXZ-","body":"AdminPage_body__Fe3fp","content":"AdminPage_content__1+9U2","header":"AdminPage_header__CaKst","title":"AdminPage_title__YKRqz"};